import React from 'react';
import {Grid, GridRow, GridColumn} from '@react/react-spectrum/Grid';
import {Field, reduxForm } from 'redux-form';
import Button from '@react/react-spectrum/Button';
import render_input from './render_input';
import validate from './validate';
import Select from '@react/react-spectrum/Select';
import {setCountry, setState} from "../../actions/UserInfoActions";
import Heading from '@react/react-spectrum/Heading';
import i18n from "../../i18n";

const selectCountry = ({ input, prop, meta: { touched, error } }) =>{
    return(
        <div className="select-option-outer">
            <Select {...input} style={{width: '100%'}}  placeholder={i18n.t('label.country')}
                change={(event) => prop.dispatch(setCountry(event))}
                options={prop.countries}
                disabled
            />
        </div>
    )
}
const selectState = ({ input, prop, meta: { touched, error } }) =>{
    const selectError = `${error && touched ? 'select-error' : ''} `;
    let stateList = [];
    prop.countryStates.forEach(element => {
        stateList.push({
            label: element.name,
            value: element.code
        })
    });
    return (
        <div className="select-option-outer">
            <Select className={selectError} {...input} style={{width: '100%'}}  placeholder={i18n.t('label.selectStateProvince')}
                change={(event) => prop.dispatch(setState(event))}
                options={stateList}
            />
    </div>
    )
}
const Address = props => {
    const { handleSubmit } = props;
    return (
        <div className="address-form-outer">
            <form onSubmit={handleSubmit}>
                <Grid variant="fixed" style={{paddingBottom: '2.5em'}}>
                    <Heading data-am-id="userAddressHeading" variant="subtitle1" className="form-heading">
                        {i18n.t('addressHeaderMessage')}
                    </Heading>
                    <GridRow>
                        <GridColumn size={[12,12,12,12]}>
                            <div className="secure-input-outer-column">
                                <label>{i18n.t('label.billingAddress')}</label>
                                <Field data-am-id="userAddress"  placeholder={i18n.t('label.billingAddress')} type="text" name="address" component={render_input}/>
                            </div>
                        </GridColumn>
                    </GridRow>  
                    <GridRow>  
                        <GridColumn size={[12,6,6,6]}>
                            <div className="secure-input-outer-column">
                                <label>{i18n.t('label.city')}</label>
                                <Field data-am-id="userCity" type="text" name="city" placeholder={i18n.t('label.city')} component={render_input}/>
                            </div>
                        </GridColumn>
                        <GridColumn size={[12,6,6,6]}>
                            <div className="secure-input-outer-column">
                                <label >{i18n.t('label.postalCode')}</label>
                                <Field data-am-id="userPostalCode" type="text" name="postalCode" placeholder={i18n.t('label.postalCode')} component={render_input}/>
                            </div>
                        </GridColumn>
                    </GridRow>
                    <GridRow>  
                        <GridColumn size={[12,6,6,6]}>
                            <div className="secure-input-outer-column">
                                <label>{i18n.t('label.stateProvince')}</label>
                                <Field data-am-id="userStateProvince" name="state" prop={props} component={selectState} value={props.stateCode}/>
                            </div>
                        </GridColumn>
                        <GridColumn size={[12,6,6,6]}>
                            <div className="secure-input-outer-column">
                                <label>{i18n.t('label.country')}</label>
                                <Field data-am-id="userCountry" name="country" component={selectCountry} value={props.userCountryCode} prop={props}/>
                            </div>
                        </GridColumn>
                    </GridRow>
                </Grid>
                <div style={{margin:'10px', textAlign:"center"}}>
                    <Button data-am-id="userAddressNextBtn" type="submit" variant="cta">{i18n.t('label.nextBtn')}</Button>
                </div>
            </form>
        </div>
    );
  };
  export default reduxForm({    
    form: 'secure_pay_form',
    validate,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  })(Address);